import { Input } from "../components/ui";
import { passwordMeter } from "../lib/passwordPolicy";

// A new-password input with the policy spelled out and a live length
// count (UX: the rule is shown before the user trips on it). The policy
// is NIST SP 800-63B rev. 4 as enforced by internal/auth/password_policy.go:
// length is the only composition rule; the server also refuses common or
// breached passwords and the account's own email.

export const PASSWORD_RULE_TEXT =
  "At least 15 characters. A few unrelated words make a strong password that's easy to remember. No symbols or numbers required.";

export function NewPasswordField({
  label = "Password",
  value,
  onChange,
  error,
}: {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  error?: string;
}) {
  return (
    <Input
      label={label}
      type="password"
      autoComplete="new-password"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      error={error}
      hint={
        <>
          {PASSWORD_RULE_TEXT} <span aria-live="off">{value ? passwordMeter(value) : ""}</span>
        </>
      }
    />
  );
}
